const XCMG_LOGIN_PATH = '/xcmg-login.html';
const WELINK_SDK_URL = 'https://open-doc.welink.huaweicloud.com/docs/jsapi/2.0.12/hwh5-cloudonline.js';
const OPEN_SOA_PROD_ORIGIN = 'https://wiop-api.jdindustry.com';
const OPEN_SOA_NON_PROD_ORIGIN = 'https://wiop-api-pre.jdindustry.com';
const OPEN_SOA_XCMG_LOGIN_PATH = '/wiep/xcmg/login';
const CODE_PLACEHOLDER = '$(code)';

interface WeLinkAuthorizationResult {
  code?: string;
}

interface WeLinkH5 {
  getAuthorizationCode: () => Promise<WeLinkAuthorizationResult>;
}

declare global {
  interface Window {
    HWH5?: WeLinkH5;
  }
}

export const isXcmgLoginPath = (pathname = window.location.pathname): boolean => pathname === XCMG_LOGIN_PATH;

const showStatus = (message: string): void => {
  const root = document.getElementById('root');
  if (root) {
    root.textContent = message;
  }
};

const getOpenSoaLoginUrl = (): string => {
  const origin = window.location.hostname === 'buy.jdindustry.com' ? OPEN_SOA_PROD_ORIGIN : OPEN_SOA_NON_PROD_ORIGIN;
  return `${origin}${OPEN_SOA_XCMG_LOGIN_PATH}`;
};

const loadWeLinkSdk = (): Promise<WeLinkH5> => {
  if (window.HWH5?.getAuthorizationCode) {
    return Promise.resolve(window.HWH5);
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = WELINK_SDK_URL;
    script.onload = () => {
      if (window.HWH5?.getAuthorizationCode) {
        resolve(window.HWH5);
      } else {
        reject(new Error('WeLink SDK不可用'));
      }
    };
    script.onerror = () => reject(new Error('WeLink SDK加载失败'));
    document.head.appendChild(script);
  });
};

const submitLogin = (code: string, payload: string): void => {
  const form = document.createElement('form');
  form.method = 'post';
  form.action = getOpenSoaLoginUrl();
  form.style.display = 'none';

  [['code', code], ['payload', payload]].forEach(([name, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
};

/**
 * 执行徐工 WeLink 免登录。配置链接已注入真实 code 时直接使用，否则通过 HWH5 获取授权码。
 * 表单采用顶层页面提交，让 open-soa 写入商城域 Cookie 后通过 302 进入商城。
 */
export const startXcmgLogin = async (): Promise<void> => {
  const searchParams = new URLSearchParams(window.location.search);
  const payload = searchParams.get('payload');
  const codeFromUrl = searchParams.get('code');

  if (!payload) {
    showStatus('登录参数无效，请从 WeLink 重新进入。');
    return;
  }

  showStatus('登录中...');

  try {
    if (codeFromUrl && codeFromUrl !== CODE_PLACEHOLDER) {
      submitLogin(codeFromUrl, payload);
      return;
    }

    const hwh5 = await loadWeLinkSdk();
    const result = await hwh5.getAuthorizationCode();
    if (!result?.code) {
      throw new Error('WeLink授权码为空');
    }
    submitLogin(result.code, payload);
  } catch (error) {
    console.error('徐工WeLink免登录失败:', error);
    showStatus('获取 WeLink 授权失败，请从 WeLink 重新进入。');
  }
};

